import { fetchData } from '@/utils/fetch'
import { toReject } from './util'

export const retrieveCurrencyList = async () => {
  return fetchData('/appb/alibaba-common/currencyList')
}

export const retrieveCountryList = async () => {
  return fetchData('/dsp-app/alibaba-common/country')
}

export const retrieveBulkTimes = toReject(() => {
  return fetchData('/appb/b2b/product/quote/bulkTimes')
})
